<template>
  <v-container class="calendar">
    <v-row>
      <v-col cols="7">
        <calendar-months-list
          @selectMonth="selectMonth"
          :viewed-month="viewedMonth"
          class="calendar--months"
        />
      </v-col>
      <v-col cols="5">
        <calendar-year
          @prevYear="prevYear"
          @nextYear="nextYear"
          :viewed-year="viewedYear"
          class="calendar--year"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <calendar-month-days
          v-on="$listeners"
          :dot-marked-dates="dotMarkedDates"
          :selectedDate="selectedDate"
          :viewed-month="viewedMonth"
          :viewed-year="viewedYear"
          :mark-weeks="markWeeks"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CalendarYear from './components/CalendarYear'
import CalendarMonthsList from './components/CalendarMonthsList'
import CalendarMonthDays from './components/CalendarMonthDays'

export default {
  name: 'Calendar',
  components: {
    CalendarYear,
    CalendarMonthsList,
    CalendarMonthDays,
  },
  props: {
    selectedDate: {
      type: Object,
      default: function() {
        return {
          year: 0,
          month: 0,
          day: 0,
        }
      },
    },
    dotMarkedDates: {
      type: Array,
      default: function() {
        return []
      },
    },
    markWeeks: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      viewedYear: 0,
      viewedMonth: 0,
    }
  },
  created() {
    this.viewedMonth = this.selectedDate.month
    this.viewedYear = this.selectedDate.year
  },
  watch: {
    selectedDate: function(val) {
      if (val) {
        if (this.viewedMonth != this.selectedDate.month)
          this.viewedMonth = this.selectedDate.month
        if (this.viewedYear != this.selectedDate.year)
          this.viewedYear = this.selectedDate.year
      }
    },
  },
  methods: {
    prevYear() {
      this.viewedYear--
      this.$emit('getCalendar', {
        month: this.viewedMonth,
        year: this.viewedYear,
      })
    },
    nextYear() {
      this.viewedYear++
      this.$emit('getCalendar', {
        month: this.viewedMonth,
        year: this.viewedYear,
      })
    },
    selectMonth(id) {
      this.viewedMonth = id
      this.$emit('getCalendar', {
        month: this.viewedMonth,
        year: this.viewedYear,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.calendar {
  padding: 24px 0px 12px;
  &--year {
    text-align: right;
    color: $bh-gray--2;
    font-size: 0.85714rem;
    .v-icon {
      font-size: 2rem !important;
    }
  }
  &--months {
    color: $bh-gray--2;
  }
}
</style>
